<script setup>
import PgeButton from '../../../../pge-components/pge-button.vue';
const props = defineProps({
	eventData: Object,
	currentFormStepData: {
		type: Object,
		default:  () => {}
	},
    emailExist: {
        type: Boolean,
        default: false
    }
});

function handleRedirect(path) {
	window.location.href = path;
}
</script>

<template>
	<div class="form">
		<div class="form__title">
			{{ props.eventData.settings.success_message_header }}
		</div>
		<div class="form__content">
            <template v-if="emailExist">
                Click the button bellow to login with your email address
            </template>
            <template v-else>
                {{ props.eventData.settings.success_message_body }}
            </template>
		</div>
		<pge-button
            :label="emailExist ? 'Login' : 'Close'"
            @click="() => { handleRedirect(emailExist ? '/login' : '/') }"
        />
	</div>
</template>

<style lang="scss" scoped>
.form {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 22px;

	&__title {
		font-style: normal;
		font-weight: 800;
		font-size: 24px;
		line-height: 29px;
		text-align: center;
		color: #000;
	}

	&__content {
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 19px;
		text-align: center;
		color: #000;

		&__title {
			font-style: normal;
			font-weight: 800;
			font-size: 24px;
			line-height: 29px;
			color: #000;
		}

		&__text {
			font-size: 16px;
			line-height: 24px;
			color: #000;
			text-align: center;
			word-wrap: break-word;
		}

		&__error {
			color: red;
		}
	}

	&__hyperlink {
		color: #5E2F78;
		font-weight: 600;
		cursor: pointer;
	}
}
</style>